document.addEventListener("DOMContentLoaded", function () {
  const quizPopup = document.getElementById("quiz-popup");
  const closeQuiz = document.getElementById("close-quiz");
  const startQuiz = document.getElementById("start-quiz");
  const nextToSizes = document.getElementById("next-to-sizes");
  const viewResults = document.getElementById("view-results");
  const restartQuiz = document.getElementById("restart-quiz");
  const radiatorQuestions = document.getElementById("radiator-questions");
  const resultProducts = document.getElementById("result-products");
  const backToIntro = document.getElementById("back-to-intro");
  const backToRadiatorCount = document.getElementById("back-to-radiator-count");
  const backToSizeQuestions = document.getElementById("back-to-size-questions");
  const addFolieBtn = document.getElementById("add-folie-btn");
  
  let radiatorCount = 0;
  let votes = {};

  const productMapping = {
    "45-65cmㅤ": [{ name: "monoset", variantId: "49490690670921", quantity: 1 }],
    "70-95cmㅤ": [{ name: "duoset", variantId: "49490690703689", quantity: 1 }],
    "100-135cmㅤ": [
      { name: "duoset", variantId: "49490690703689", quantity: 1 },
      { name: "uitbreidingsset", variantId: "49490690769225", quantity: 1 },
    ],
    "140-175cmㅤ": [{ name: "3+1 gratis", variantId: "49490690736457", quantity: 1 }],
    "180-215cmㅤ": [
      { name: "3+1 gratis", variantId: "49490690736457", quantity: 1 },
      { name: "uitbreidingsset", variantId: "49490690769225", quantity: 1 },
    ],
    "220-255cmㅤ": [
      { name: "3+1 gratis", variantId: "49490690736457", quantity: 1 },
      { name: "uitbreidingsset", variantId: "49490690769225", quantity: 2 },
    ],
    "260-295cmㅤ": [
      { name: "3+1 gratis", variantId: "49490690736457", quantity: 1 },
      { name: "uitbreidingsset", variantId: "49490690769225", quantity: 3 },
    ],
  };
  closeQuiz.addEventListener("click", function () {
    quizPopup.style.display = "none";  // Verberg het popup-venster
  });
  const sizeGroups = [
    ["45-65cmㅤ", "70-95cmㅤ", "100-135cmㅤ"],
    ["140-175cmㅤ", "180-215cmㅤ", "220-255cmㅤ"],
    ["260-295cmㅤ"],
  ];

  const productPrices = {
    monoset: "€49,95",
    duoset: "€94,95",
    "3+1 gratis": "€139,95",
    uitbreidingsset: "€45,95",
  };

  const productImages = {
    monoset: "https://cdn.shopify.com/s/files/1/0774/0332/4745/files/Radiatorventilator-_Comfort-Booster_-My-Store-189965464.png?v=1731871747",
    duoset: "https://cdn.shopify.com/s/files/1/0774/0332/4745/files/Radiatorventilator-_Comfort-Booster_-My-Store-189965513.png?v=1731871750",
    "3+1 gratis": "https://cdn.shopify.com/s/files/1/0774/0332/4745/files/Radiatorventilator-_Comfort-Booster_-My-Store-189965667.png?v=1731871753",
    uitbreidingsset: "https://cdn.shopify.com/s/files/1/0774/0332/4745/files/Radiatorventilator-_Comfort-Booster_-My-Store-189965751.png?v=1731871756",
  };
  document.addEventListener("DOMContentLoaded", function () {
  const addFolieBtn = document.getElementById("add-folie-btn");

  addFolieBtn.addEventListener("click", function () {
    const quantity = parseInt(document.getElementById("folie-quantity").value);
    const folieVariantId = "8672617660745"; // Vervang met de juiste variant-ID

    if (quantity > 0) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: folieVariantId, quantity }],
        }),
      })
        .then(() => alert(`${quantity}x Radiatorfolie toegevoegd aan winkelwagen!`))
        .catch(() => alert("Fout bij toevoegen. Probeer opnieuw."));
    } else {
      alert("Selecteer een geldig aantal.");
    }
  });
});

  // Dynamische navigatie
  function showPage(currentPageId, nextPageId) {
    document.getElementById(currentPageId).classList.remove("active");
    document.getElementById(nextPageId).classList.add("active");
  }

  startQuiz.addEventListener("click", function () {
    showPage("quiz-page-1", "quiz-page-2");
  });

  nextToSizes.addEventListener("click", function () {
    radiatorCount = parseInt(
      document.querySelector('input[name="radiator_count"]:checked').value
    );

    radiatorQuestions.innerHTML = "";

    for (let i = 1; i <= radiatorCount; i++) {
      const questionDiv = document.createElement("div");
      questionDiv.innerHTML = `
        <h3 style="font-weight: bold; font-size: 1.1rem;">Afmetingen radiator #${i} :</h3>
        <form class="size-form" data-index="${i}">
          ${sizeGroups
            .map((group) =>
              group
                .map(
                  (size) =>
                    `<label><input type="radio" name="radiator_${i}" value="${size}"> ${size}</label>`
                )
                .join("")
            )
            .join("<br>")}
        </form>
      `;
      radiatorQuestions.appendChild(questionDiv);
    }

    showPage("quiz-page-2", "quiz-page-3");
  });

viewResults.addEventListener("click", function () {
  const forms = document.querySelectorAll(".size-form");
  votes = {};
  const allItems = [];

  forms.forEach((form) => {
    const size = form.querySelector('input[type="radio"]:checked').value;
    const index = form.getAttribute("data-index");
    votes[index] = size;
  });

  resultProducts.innerHTML = "";

  Object.keys(votes).forEach((index) => {
    const size = votes[index];
    const productList = productMapping[size];

    const resultDiv = document.createElement("div");
    resultDiv.classList.add("radiator-section");
    resultDiv.innerHTML = `
      <div class="radiator-header">
        <h3 style="font-weight: bold; font-size: 1.0rem;">Radiator #${index} <span style="font-size: 0.9rem; font-weight: normal;">➩ ${size}</span></h3>
      </div>
      <ul class="product-list">
        ${productList
          .map(
            (product) =>
              `<li>
                <img src="${productImages[product.name]}" alt="${product.name}" />
                <div class="product-info">
                  <strong>${product.quantity}x</strong>
                  <span>${product.name}</span>
                  <span class="product-price">${productPrices[product.name]}</span>
                </div>
                <button class="add-single-btn" data-variant-id="${product.variantId}" data-quantity="${product.quantity}">+</button>
              </li>`
          )
          .join("")}
      </ul>
    `;
    productList.forEach((product) =>
      allItems.push({ id: product.variantId, quantity: product.quantity })
    );
    resultProducts.appendChild(resultDiv);
  });

  const addAllButton = document.createElement("button");
  addAllButton.textContent = "Alles toevoegen 🛒";
  addAllButton.classList.add("add-all-btn");
  addAllButton.addEventListener("click", function () {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: allItems }),
    })
      .then(() => {
        window.location.href = "/cart";
      })
      .catch(() => alert("Fout bij toevoegen."));
  });
  resultProducts.appendChild(addAllButton);

  document.querySelectorAll(".add-single-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const quantity = parseInt(this.getAttribute("data-quantity"));
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
        }),
      })
        .then(() => alert("Product toegevoegd!"))
        .catch(() => alert("Fout bij toevoegen."));
    });
  });
const offerSection = document.createElement("div");
offerSection.classList.add("folie-section");
offerSection.innerHTML = `
<hr>
<p class="kassakoopje-title"><b>Kassakoopje:</b></p>
<div>
  <span class="smaller-text">Voeg radiatorfolie toe:</span>
  <span class="smaller-text"><b>Ontvang 5% korting op totale bestelling</b></span>
</div>
<div class="product-link-container">
  <div class="product-popup">
    <button class="popup-close-btn">✖</button>
    <img src="https://cdn.shopify.com/s/files/1/0774/0332/4745/files/Radiatorfolie-_ISO-Comfort_-_20mm_-My-Store-182555019.png?v=1730636172" alt="Product Image" class="popup-image">
    <br>
    <h3 class="popup-title">ISO Comfort Radiatorfolie</h3>
    <p class="popup-description">
      Plaats de 'ISO Comfort' radiatorfolie tegen de muur achter uw radiator en bespaar tot 14 kuub gas per m² radiatorfolie per jaar. 
      Met zijn extra dikke isolerende coating van 2 cm biedt de 'ISO Comfort' ongeëvenaarde isolatieprestaties voor optimale resultaten. 
      <br><b>Afmetingen: 300CM x 50CM</b>
    </p>
    <p class="popup-price">€39,95</p>
  </div>
</div>
<div class="folie-select">
  <label for="folie-quantity">Aantal:</label>
  <input type="number" id="folie-quantity" min="1" max="99" value="1" style="width: 60px; text-align: center;" />
</div>
<div class="product-description">
  <div class="discount-row">
    <b>Kortingscode:</b>
    <button id="copy-code-btn" class="copy-code-btn">📋 5KORTINGFOLIE</button>
  </div>
  <span class="smaller-text1">[Kopieer en plak deze kortingscode op de betaalpagina]</span>
</div>
<div class="button-container">
  <button id="add-folie-btn" class="quiz-btn add-folie-btn">➕ Toevoegen Kassakoopje</button>
  <button id="view-cart-btn" class="quiz-btn">Bekijk winkelwagen 🛒</button>
</div>

`;

resultProducts.appendChild(offerSection);

document.getElementById('view-cart-btn').addEventListener('click', function() {
  // Voeg hier de actie toe om naar de winkelwagenpagina te navigeren
  window.location.href = '/cart'; // Dit zou de gebruiker naar de winkelwagenpagina moeten sturen
});

// Functie om de kortingscode te kopiëren naar het klembord
document.getElementById('copy-code-btn').addEventListener('click', function() {
  const el = document.createElement('textarea');
  el.value = '5KORTINGFOLIE'; // De kortingscode die gekopieerd moet worden
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  alert('Kortingscode gekopieerd naar klembord!');
});


document.querySelectorAll('.product-link').forEach(link => {
    link.addEventListener('click', (event) => {
        event.preventDefault(); // Voorkom dat de link opent
    });

    link.addEventListener('mouseover', (event) => {
        const popup = link.nextElementSibling;
        const [title, description, price, imageSrc] = link.dataset.productInfo.split('|');

        // Update de inhoud van de popup
        popup.querySelector('.popup-title').textContent = title;
        popup.querySelector('.popup-description').textContent = description;
        popup.querySelector('.popup-price').textContent = price;
        popup.querySelector('.popup-image').src = imageSrc;

        // Toon de popup
        popup.style.display = 'block';
        popup.style.opacity = '1';
        popup.style.visibility = 'visible';
    });
});

document.querySelectorAll('.popup-close-btn').forEach(button => {
    button.addEventListener('click', (event) => {
        const popup = button.parentElement;
        popup.style.opacity = '0';
        popup.style.visibility = 'hidden';
        setTimeout(() => (popup.style.display = 'none'), 300); // Wacht tot overgang eindigt
    });
});

// Activeer de logica voor de folie-knop
const addFolieBtn = document.getElementById("add-folie-btn");
addFolieBtn.addEventListener("click", function () {
  const quantity = parseInt(document.getElementById("folie-quantity").value);
  const folieVariantId = "48684476596553"; // Vervang met de juiste variant-ID

  if (quantity > 0) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: folieVariantId, quantity }],
      }),
    })
      .then(() => alert(`${quantity}x Radiatorfolie toegevoegd aan winkelwagen!`))
      .catch(() => alert("Fout bij toevoegen. Probeer opnieuw."));
  } else {
    alert("Selecteer een geldig aantal.");
  }
});

  showPage("quiz-page-3", "quiz-results");
});
  restartQuiz.addEventListener("click", function () {
    radiatorCount = 0;
    votes = {};
    document.querySelectorAll('input[type="radio"]:checked').forEach((input) => (input.checked = false));
    resultProducts.innerHTML = "";
    showPage("quiz-results", "quiz-page-1");
  });

  // Terug naar Intro Pagina
  backToIntro.addEventListener("click", function () {
    showPage("quiz-page-2", "quiz-page-1");
  });

  // Terug naar Radiator Aantal Pagina
  backToRadiatorCount.addEventListener("click", function () {
    showPage("quiz-page-3", "quiz-page-2");
  });

  // Terug naar Radiator Afmetingen Pagina
  backToSizeQuestions.addEventListener("click", function () {
    showPage("quiz-results", "quiz-page-3");
  });
});